import {
  Backdrop,
  Box,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Layout from "../../../layout/Layout";
import GroupCard from "../../../components/Groups/GroupCard";
import GroupDetailModal from "../../../components/Modals/GroupDetailModal";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../../components/Common/CustomSnackbar";
import CreateGroupModal from "../../../components/Modals/CreateGroupModal";
import { useDispatch, useSelector } from "react-redux";
import { getAllGroups } from "../../../redux/dispatchers/groups.dispatcher";
import axiosInstance from "../../../utils/config/config";
import { getUserById } from "../../../redux/dispatchers/users.dispatcher";

const Groups = () => {
  const dispatch = useDispatch();

  const { allGroups } = useSelector((state) => state.groups);
  const { userData } = useSelector((state) => state.user);

  const [createGroup, setCreateGroup] = useState(false);
  const [groupDetail, setGroupDetail] = useState(false);
  const [groupId, setGroupId] = useState(null);

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorState, setErrorState] = useState({
    error: false,
    errorMsg: "",
  });

  useEffect(() => {
    dispatch(getAllGroups());
  }, []);

  const joinGroup = async (id, groupId) => {
    try {
      setLoading(true);
      const response = await axiosInstance.post("/group/createGroupMember", {
        user_id: id,
        group_id: groupId,
        created_by: null,
        role: "",
        status: "active",
      });

      if (response.status === 200) {
        setSuccess(true);
        console.log("Group Joined Successfully");
        dispatch(getAllGroups());
        dispatch(getUserById());

        setLoading(false);
      }
    } catch (error) {
      console.error("Error joining group:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const myGroups = allGroups?.filter(
    (group) => group?.user?.id === userData?.id
  );

  return (
    <Layout
      heading="Groups"
      hideSideBar={groupDetail || createGroup}
      onCreate={() => setCreateGroup(true)}
    >
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, errorMsg: "" })}
        errorMsg={errorState.errorMsg}
      />
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={() => setSuccess(false)}
        text="Group Created Successfully"
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1} mb={2}>
          <Typography
            sx={{
              color: "#fff",
              fontSize: "20px",
              fontFamily: "Mulish-Medium",
            }}
          >
            Popular Groups ({allGroups?.length || 0})
          </Typography>
          <Box
            sx={{
              backgroundColor: "transparent",
              border: "1px solid rgba(255,255,255,0.22)",
              borderRadius: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 1,
              px: 2,
              color: "#fff",
              fontFamily: "Mulish-Light",
              fontSize: "12px",
            }}
          >
            My Groups ({myGroups?.length || 0})
          </Box>
          {/* <Box
            sx={{
              backgroundColor: "transparent",
              border: "1px solid rgba(255,255,255,0.22)",
              borderRadius: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 1,
              px: 2,
              color: "#fff",
              fontFamily: "Mulish-Light",
              fontSize: "12px",
            }}
          >
            Invited (0)
          </Box> */}
        </Stack>

        {allGroups?.map((item, index) => (
          <GroupCard
            item={item}
            index={index}
            key={index}
            setGroupDetail={setGroupDetail}
            setGroupId={setGroupId}
            joinGroup={joinGroup}
          />
        ))}
      </Box>

      <GroupDetailModal
        open={groupDetail}
        onClose={() => setGroupDetail(false)}
        groupId={groupId}
        joinGroup={joinGroup}
      />
      <CreateGroupModal
        open={createGroup}
        onClose={() => setCreateGroup(false)}
        setLoading={setLoading}
        setErrorState={setErrorState}
        setSuccess={setSuccess}
      />
    </Layout>
  );
};

export default Groups;
